<template>
  <pop-up-layout
    :title="!editar ? localization.titleCrear : localization.titleEditar + ' ' + item.name"
    :description="localization.subtitle"
    :loading="loading"
    :saving="waitingForLoad"
    aceptar="Aceptar"
    @volver="cerrarPopup()"
    @aceptar="enviarCliente()"
  >
    <Alerts></Alerts>
    <v-form v-model="valid" id="valid" ref="formClientes" autocomplete="off" >
    <v-col cols="12">
      <v-row class="pl-6">
        <v-col cols="2" md="2">
           <v-text-field 
                  :rules="[rules.obligatorio, rules.max(100)]"
                  v-model="codigo" 
                  id="codigo"
                  :label="localization.codigo"
                  maxlength="101"
                />
        </v-col>
        <v-col cols="6" md="6">
            <v-text-field 
                  :rules="[rules.obligatorio, rules.max(100)]"
                  v-model="nombre" 
                  id="nombre" 
                  :label="localization.nombre" 
                  maxlength="101"
                />
        </v-col>
        <v-col cols="4" md="4">
            <v-autocomplete 
                  v-model="sociedadSelectedId" 
                  id="sociedadSelectedId"
                  :items="sociedades" 
                  item-text="name"
                  item-value="id"
                  :label="localization.sociedad"
                />
        </v-col>
        <v-col cols="12" pl-6>
          <v-row>
            <h2 class="primary--text text-uppercase" style="font-size: 18px">
              datos de contacto
            </h2>
          </v-row>
          <v-row style="padding-left:0px">
            <v-col cols="12" style="padding-left:0px">
              <v-divider class="divider_subtitle" style="padding-left:0px"></v-divider>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="3" md="3"> 
         <v-text-field 
                  :rules="[rules.phoneNumber, rules.max(100)]"
                  v-model="telefono" 
                  id="telefono" 
                  :label="localization.telefono" 
                  maxlength="101"
                />
        </v-col>
        <v-col cols="3" md="3">
         <v-text-field 
                  :rules="[rules.phoneNumber, rules.max(100)]"
                  v-model="movil" 
                  id="movil" 
                  :label="localization.movil" 
                  maxlength="101"
                />
        </v-col>
        <v-col cols="3" md="3">
         <v-text-field 
                  :rules="[rules.email, rules.max(100)]"
                  v-model="email" 
                  id="email" 
                  :label="localization.email" 
                  maxlength="101"
                />
        </v-col>
      </v-row>
    </v-col>
    </v-form>
  </pop-up-layout>
</template>

<script>
import { mapActions } from 'vuex'
import rulesMixin from '@/components/generic/rules.js'
import Alerts from '@/components/Alerts'

export default {
  components: {
    Alerts,
  },
  mixins: [rulesMixin],
  props: {
    item: null,
    editar: null
  },
  data () {
    return {
      valid: false,
      waitingForLoad: false,
      loading: false,
      codigo: null,
      nombre: null,
      telefono: null,
      movil: null,
      email: null,
      //CAMPOS DE OPERACION
      clienteSelectedId: null, 
      sociedadSelectedId: null,
    }
  },
  async created () {
    if(this.editar === true)
    {
      this.codigo = this.item.code
      this.sociedadSelectedId = this.item.idSociedad
      this.nombre = this.item.name
      this.email = this.item.email
      this.telefono = this.item.telefono
      this.movil = this.item.movil
    }    
  },
  computed: {
    cliente(){
      const value = {
        idSociedad: this.sociedadSelectedId,
        name: this.nombre,
        code: this.codigo,
        email: this.email,
        telefono: this.telefono,
        movil: this.movil
      }
      return value
    },
    sociedades(){
      if (this.$store.state.gestion.societies) {
        return this.$store.state.gestion.societies
      }
      return []
    },  
    localization () {
      return this.$t('popUpCrearClientes')
    },
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
    }),
    cerrarPopup() {
      this.$parent.hide()
      this.$parent.$parent.sheet = true

    },
    async enviarCliente(){
      this.$refs.formClientes.validate()
      if (!this.valid) {
        this.addAlert({texto: 'Por favor, revise los campos marcados en rojo', color: 'error'})
      } else {
        this.$emit('aceptar', this.cliente) 
      this.cerrarPopup() 
      }
    },
  },
}
</script>

<style scoped>
  .info-tooltip {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.54);
    font-weight: bold;
    margin-bottom: 0px;
  }
</style>